interface OtherViewData {
  note: string
}

export const otherViewData: OtherViewData[] = [
  {
    note: `1. Check if any configuration different from the default.
		2. Check if any change over history.`
  }
]
